import "./style.css";

const Page404 = () => {
  return (
    <div className="page404">
      <div className="content">404 Not Found</div>
    </div>
  )
}

export default Page404